(function ($) {
    $.fn.pdfGenerator = function () {
        return this.each(function () {
            var body = $('body');
            var inputElementId = $(this).attr('input-id');
            var printStyle = $(this).attr('print-style');
            var feedbackLink = $(this).attr('feedback-link').slice(0, -1);
            var pdfFile = null;
        
            var formatOptions = {
                Letter: [612, 792],
                Legal: [612, 1008],
                Tabloid: [792, 1224],
                A3: [841.89, 1190.55],
                A4: [595.28, 841.89],
                A5: [419.53, 595.28]
            };

            // Create the main container div
            var exportPopup = $('<div>', {
                id: 'pdf-generator-popup',
                class: 'pdf-generator-popup'
            });

            // Create the export preview div
            var exportPreviewDiv = $('<div>', {
                class: 'pdf-generator-preview'
            });
            exportPopup.append(exportPreviewDiv);

            // Create the export options div
            var exportOptionsDiv = $('<div>', {
                class: 'pdf-generator-options'
            });

            // Create the pdf-generator-title div
            var titleDiv = $('<div>', {
                class: 'pdf-generator-title',
                text: 'Export'
            });
            exportOptionsDiv.append(titleDiv);

            // Create the form inputs div
            var formInputsDiv = $('<div>', {
                class: 'pdf-generator-form-inputs'
            });

            // Create the input group for the pageSize
            var pageSizeInputGroup = $('<div>', {
                class: 'pdf-generator-input-group'
            });

            var pageSizeLabel = $('<label>', {
                text: 'Page Size'
            });
            pageSizeInputGroup.append(pageSizeLabel);

            var pageSizeContainer = $('<div>');

            var pageSizeSelect = $('<select>', {
                class: 'page-size-select'
            });

            for (var option in formatOptions) {
                var pageSizeOption = $('<option>', {
                    value: option,
                    text: option
                });
                pageSizeSelect.append(pageSizeOption);

                if (option === 'A4') {
                    pageSizeOption.prop('selected', true);
                }
            }

            pageSizeContainer.append(pageSizeSelect);

            var validationMessageDiv = $('<div>', {
                class: 'pdf-generator-validation-message'
            });
            pageSizeContainer.append(validationMessageDiv);

            pageSizeInputGroup.append(pageSizeContainer);

            formInputsDiv.append(pageSizeInputGroup);

            // Create the input group for the layout
            var layoutInputGroup = $('<div>', {
                class: 'pdf-generator-input-group'
            });
 

            var layoutLabel = $('<label>', {
                text: 'Layout'
            });
            layoutInputGroup.append(layoutLabel);

            var layoutSelect = $('<select>', {
                class: 'layout-select'
            });

            var portraitOption = $('<option>', {
                value: 'portrait',
                text: 'Portrait'
            });
            layoutSelect.append(portraitOption);

            var landscapeOption = $('<option>', {
                value: 'landscape',
                text: 'Landscape'
            });
            layoutSelect.append(landscapeOption);

            layoutInputGroup.append(layoutSelect);
            formInputsDiv.append(layoutInputGroup);



            // Create the main container div
            var feedbackDiv = $('<div>').addClass('feedback mt-3');

            // Create the feedback text div
            var feedbackTextDiv = $('<div>').addClass('feedback-text').text('Are you satisfied with the AI-generated Question Paper?');

            // Create the feedback icons div
            var feedbackIconsDiv = $('<div>').addClass('feedback-icons');

            // Create the first feedback icon div
            var emojiF3Div = $('<div>').addClass('emoji f3').attr('act-on', 'click').attr('act-request', feedbackLink + '3');
            var emojiF3Svg = `<svg width="30" height="30" viewBox="0 0 109 109" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M107.741 62.0867C104.928 77.8102 97.4193 90.1011 84.4896 98.8817C71.8701 107.452 57.9203 110.049 43.0972 107.065C11.7582 100.757 -7.27731 67.837 2.63685 37.4882C13.0151 5.71875 49.2708 -9.30126 78.8589 6.07697C98.767 16.4241 110.693 37.0795 107.741 62.0867ZM32.2371 73.1099C42.4768 87.2087 65.6148 86.3508 74.6959 74.7138C78.6017 69.7087 79.8172 66.6782 76.893 64.4546C72.7866 61.332 70.4962 63.9736 68.1566 66.6721C67.8288 67.0501 67.5001 67.4292 67.1653 67.7938C59.7319 75.8875 46.7283 75.257 40.3159 66.4793C38.1584 63.5259 35.4384 61.8098 32.3143 63.8569C28.8887 66.1016 29.456 69.4795 32.2371 73.1099ZM33.2214 49.2253C37.9158 49.2253 41.7214 45.4197 41.7214 40.7253C41.7214 36.0309 37.9158 32.2253 33.2214 32.2253C28.527 32.2253 24.7214 36.0309 24.7214 40.7253C24.7214 45.4197 28.527 49.2253 33.2214 49.2253ZM74.2214 49.2253C78.9158 49.2253 82.7214 45.4197 82.7214 40.7253C82.7214 36.0309 78.9158 32.2253 74.2214 32.2253C69.527 32.2253 65.7214 36.0309 65.7214 40.7253C65.7214 45.4197 69.527 49.2253 74.2214 49.2253Z" fill="currentColor"/></svg>`;
            emojiF3Div.append(emojiF3Svg);
            feedbackIconsDiv.append(emojiF3Div);

            var emojiF2Div = $('<div>').addClass('emoji f2').attr('act-on', 'click').attr('act-request', feedbackLink + '2');
            var emojiF2Svg = `<svg width="30" height="30" viewBox="0 0 109 109" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.7179 90.1203C0.102078 74.3837 -3.3703 55.836 4.03064 35.9152C15.7282 4.42933 54.3571 -9.24944 83.2466 9.27937C117.315 31.1298 117.573 81.1822 80.2073 102.633C78.0717 103.859 75.6859 104.65 73.1779 105.481C72.0106 105.868 70.8168 106.263 69.6095 106.715C47.3615 112.417 28.3313 107.01 13.7179 90.1203ZM42.3422 63.6561C40.4081 63.658 38.474 63.657 36.5399 63.6464C33.1522 63.6277 30.4624 64.7582 30.1287 68.1764C30.1065 68.4043 30.0947 68.6423 30.0939 68.8909C30.0805 72.9775 33.0923 73.9998 36.6098 73.9999C39.8768 73.9999 43.1438 74.0016 46.4109 74.0032L51.3027 74.0055C58.3686 74.0082 65.4345 74.0071 72.5003 73.9863C75.9502 73.976 79.0013 73.0938 78.8879 68.8319C78.7936 65.2989 76.6978 63.9544 73.7464 63.6881C73.3248 63.6501 72.8857 63.634 72.4324 63.6367C68.4147 63.6605 64.3969 63.6627 60.234 63.6592C59.5201 63.6586 58.8041 63.6578 58.0854 63.6569L56.1002 63.6544C53.7695 63.6514 51.408 63.6483 49.0029 63.6481L48.5034 63.6481C47.293 63.6485 46.0825 63.6505 44.8721 63.6525L43.2928 63.6549C42.9759 63.6554 42.6591 63.6558 42.3422 63.6561ZM74.9895 33.0151C75.1584 33.0051 75.3286 33 75.5 33C80.1944 33 84 36.8056 84 41.5C84 46.1944 80.1944 50 75.5 50C70.8056 50 67 46.1944 67 41.5C67 38.1388 68.9509 35.2332 71.7823 33.854C72.8297 33.2777 73.9091 32.9998 74.9895 33.0151ZM34.5 50C39.1944 50 43 46.1944 43 41.5C43 36.8056 39.1944 33 34.5 33C29.8056 33 26 36.8056 26 41.5C26 46.1944 29.8056 50 34.5 50Z" fill="currentColor"/></svg>`;
            emojiF2Div.append(emojiF2Svg);
            feedbackIconsDiv.append(emojiF2Div);

            var emojiF1Div = $('<div>').addClass('emoji f1').attr('act-on', 'click').attr('act-request', feedbackLink + '1');
            var emojiF1Svg = `<svg width="30" height="30" viewBox="0 0 108 108" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M108 54C108 83.8234 83.8234 108 54 108C24.1766 108 0 83.8234 0 54C0 24.1766 24.1766 0 54 0C83.8234 0 108 24.1766 108 54ZM76.505 73.7043C79.0568 77.0517 79.6241 80.4296 76.1985 82.6743C73.0744 84.7214 70.3544 83.0053 68.1969 80.0519C61.7845 71.2742 48.7809 70.6438 41.3476 78.7374C41.0128 79.102 40.684 79.4811 40.3563 79.8591C38.0167 82.5576 35.7262 85.1992 31.6198 82.0767C28.6956 79.8531 29.9111 76.8226 33.8169 71.8175C42.898 60.1804 66.036 59.3226 76.505 73.7043ZM33.5 48C38.1944 48 42 44.1944 42 39.5C42 34.8056 38.1944 31 33.5 31C28.8056 31 25 34.8056 25 39.5C25 44.1944 28.8056 48 33.5 48ZM74.5 48C79.1944 48 83 44.1944 83 39.5C83 34.8056 79.1944 31 74.5 31C69.8056 31 66 34.8056 66 39.5C66 44.1944 69.8056 48 74.5 48Z" fill="currentColor"/></svg>`;
            emojiF1Div.append(emojiF1Svg);
            feedbackIconsDiv.append(emojiF1Div);


            // Append the feedbackTextDiv and feedbackIconsDiv to the main feedbackDiv
            feedbackDiv.append(feedbackTextDiv);
            feedbackDiv.append(feedbackIconsDiv);

            // Append the feedbackDiv to the target element (formInputsDiv)
            formInputsDiv.append(feedbackDiv);



            exportOptionsDiv.append(formInputsDiv);

            // Create the form buttons div
            var formButtonsDiv = $('<div>', {
                class: 'pdf-generator-form-buttons'
            });

            var cancelButton = $('<button>', {
                class: 'cancel',
                type: 'button',
                text: 'Cancel'
            });
            formButtonsDiv.append(cancelButton);
            cancelButton.on('click', function () {
                if (saveButton.prop('disabled')) {
                    return;
                }
                exportPopup.addClass('closing');
                setTimeout(function () {
                    exportPopup.removeClass('opening');
                    body.css('overflow-y', 'auto');
                    exportPopup.removeClass('closing');
                }, 100);

                validationMessageDiv.text('');
            });

            var saveButton = $('<button>', {
                class: 'pdf-generator-primary',
                type: 'button',
                text: 'Download'
            });
            formButtonsDiv.append(saveButton);

            saveButton.on('click', function () {
                if(pdfFile){
                    pdfFile.save('question-paper.pdf');
                }
            });

            exportOptionsDiv.append(formButtonsDiv);
            exportPopup.append(exportOptionsDiv);

            // Append the exportPopup to the end of the body
            $('body').append(exportPopup);

            var pdfGenerate = function () {
                exportPopup.addClass('opening');
                body.css('overflow-y', 'hidden');

                var layoutSelect = $('.layout-select');
                var layout = layoutSelect.val();

                var pageSizeSelect = $('.page-size-select');
                var pageSize = pageSizeSelect.val();

                var exportPreview = $('.pdf-generator-preview');
                var loadingDiv = $('<div>', {
                    class: 'pdf-generator-loading',
                    text: 'Loading...'
                });
                exportPreview.html('');
                exportPreview.append(loadingDiv);

                // Create the main HTML elements
                var htmlElement = $('<html>');
                var headElement = $('<head>');
                var bodyElement = $('<body>');

                // Set the language attribute for the html element
                htmlElement.attr('lang', 'en');

                // Create the meta elements
                var metaCharsetElement = $('<meta>').attr('charset', 'UTF-8');
                var metaViewportElement = $('<meta>')
                    .attr('name', 'viewport')
                    .attr('content', 'width=device-width, initial-scale=1.0');

                // Create the pdf-generator-title element
                var titleElement = $('<title>').text('Document');

                // Append the meta elements and pdf-generator-title to the head
                headElement.append(metaCharsetElement);
                headElement.append(metaViewportElement);
                headElement.append(titleElement);
                
                // Create the style element for print style
                var printStyleElement = $('<link>', {
                    rel: 'stylesheet',
                    href: printStyle
                });
                headElement.append(printStyleElement);

                // Append the head to the html
                htmlElement.append(headElement);
 
                // Create the content div
                var contentDiv = $('<div>').addClass('paper');
                contentDiv.html($('#' + inputElementId).html());
                

                // Append the content div to the body
                bodyElement.append(contentDiv);

                // Append the body to the html
                htmlElement.append(bodyElement);


                html2pdf()
                    .set({
                        margin: [0.3, 0.4, 0.3, 0.4],
                        filename: 'question-paper.pdf',
                        pagebreak: { mode: ['css', 'legacy'], avoid: '.avoid-pagebreak'},
                        lazyRendering: true,
                        enableLinks: false,
                        html2canvas: { scale: 2, logging: true, dpi: 192, letterRendering: true },
                        jsPDF: { unit: 'in', format: pageSize, orientation: layout }
                    })
                    .from(htmlElement[0])
                    .toPdf()
                    .get('pdf')
                    .then(function (pdf) {
                        var totalPages = pdf.internal.getNumberOfPages();
                        for (var i = 1; i <= totalPages; i++) {
                            pdf.setPage(i);
                            pdf.setFontSize(8);
                            pdf.setTextColor(150);
                            pdf.text('Page ' + i + ' of ' + totalPages, 0.4, pdf.internal.pageSize.height - 0.2);
                        }
                        pdfFile = pdf;
                        var pdfDataBlob = pdf.output('blob');
                        var pdfDataUri = URL.createObjectURL(pdfDataBlob);

                        // var dataBlob = new Blob([htmlElement[0].outerHTML], { type: 'text/html' });
                        // var pdfDataUri = URL.createObjectURL(dataBlob);

                        var iframeElement = $('<iframe>', {
                            class: 'pdf-generator-content',
                            title: 'Embedded PDF',
                            src: pdfDataUri + '#toolbar=0&statusbar=0',
                            style: 'overflow: auto; width: 100%; height: 100%; border: none;'
                        });

                        exportPreview.html('');
                        exportPreview.append(iframeElement);
                        exportPreview.append(loadingDiv);

                        setTimeout(function () {
                            $('.pdf-generator-content').addClass('active');
                            // $('.pdf-generator-content').contents().find('body > embed').css('transform', 'scale(1.013)');
                        }, 300);

                    });

            };

            $(this).on('generate', function (e) {
                e.preventDefault();
                pdfGenerate();
            });

            $('.layout-select').on('change', function () {
                pdfGenerate();
            });

            $('.page-size-select').on('change', function () {
                pdfGenerate();
            });
        });
    };
})(jQuery);  